module.exports = __webpack_public_path__ + "static/media/bts1.aa177ec0.jpg";